import { ComponentList } from '../../components/core/component-list.js';
import { EntityMixin } from '../../components/core/entity-mixin.js';
import { JSONUtils } from '../../utility/json-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isSameData } from '../dto/data-model-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../dto/data-model.js';

export class ArtistProfile extends EntityMixin(DataModel) {
  static readonly TYPE_ID: string = '1239912cb3e04963b2f03157bbdae904';

  private constructor(
    public readonly uniqueId: string,
    public readonly webRoute: string | null,
    public readonly components: ComponentList,
  ) {
    super();
  }

  get $typeId(): string {
    return ArtistProfile.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    webRoute: string | null,
    components: ComponentList,
  }): ArtistProfile {
    return new ArtistProfile(
        args.uniqueId,
        args.webRoute,
        args.components,
    );
  }

  static fromMap(
      context: SerializationContext,
      map: SerializedData,
  ): ArtistProfile {
    return ArtistProfile.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      webRoute: MapUtils.getStringOrNull(map, 'webRoute'),
      components: ComponentList.deserialize(
          context, MapUtils.getList<SerializedData>(map, 'components', (data) => JSONUtils.decodeRecord(data)),
      ),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      webRoute: this.webRoute,
      components: this.components.serialize(context),
    };
  }

  clone(): this {
    return ArtistProfile.create({
      uniqueId: this.uniqueId,
      webRoute: this.webRoute,
      components: this.components.clone(),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.webRoute === this.webRoute &&
        isSameData(other.components, this.components);
  }
}

export class ArtistProfileBuilder extends DataModelBuilder<ArtistProfile> {
  build(context: SerializationContext, map: SerializedData): ArtistProfile {
    return ArtistProfile.fromMap(context, map);
  }
}
